export default __webpack_public_path__ + "static/media/13_1.3381842e.jpg";